// extracted by mini-css-extract-plugin
export default {"SpinFullscreen":"SpinFullscreen_SpinFullscreen__fvhK4","dots-resize":"SpinFullscreen_dots-resize__RMKh3"};